import classNames from 'classnames';
import React, { useRef } from 'react';
import useHasScrollbar from '../../tools/hooks/useHasScrollbar';

interface ScrollableProps {
  children: React.ReactNode;
  additionalClassName?: string;
  scrollAdditionClassName?: string;
  containerRef?: React.RefObject<HTMLDivElement | null>;
  noScroll?: boolean;
}

const Scrollable = ({
  children,
  additionalClassName,
  scrollAdditionClassName,
  containerRef,
  noScroll = false,
}: ScrollableProps) => {
  const internalRef = useRef<HTMLDivElement>(null);
  const currentRef = containerRef || internalRef;
  const { hasVerticalScrollbar } = useHasScrollbar(currentRef);

  return (
    <div
      ref={currentRef}
      className={classNames({
        scrollable: !noScroll,
        [`${additionalClassName}`]: !!additionalClassName,
        [`${scrollAdditionClassName}`]: hasVerticalScrollbar && !!scrollAdditionClassName,
      })}
    >
      {children}
    </div>
  );
};

export default Scrollable;
